import React, { useState, useEffect, useCallback } from 'react';
import './pc.less';
import * as icons from '../../assets/icons';

const NAV_ITEMS = [
  { id: 'features', label: '核心能力', target: '#features' },
  { id: 'ai-agents', label: 'AI 智能体', target: '#tech', techTab: 'ai' },
  { id: 'security', label: '安全与合规', target: '#tech', techTab: 'security' },
  { id: 'use-cases', label: '应用场景', target: '#use-cases' },
  { id: 'deployment', label: '部署与交付', target: '#deployment' },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [activeNav, setActiveNav] = useState('features');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const y = Number(window.scrollY);
      setScrolled(y > 16);

      const sections = [
        { id: 'deployment', el: document.querySelector('#deployment') },
        { id: 'use-cases', el: document.querySelector('#use-cases') },
        { id: 'tech', el: document.querySelector('#tech') },
        { id: 'features', el: document.querySelector('#features') },
      ];

      const triggerLine = y + 140;
      for (const sec of sections) {
        if (sec.el && sec.el.offsetTop <= triggerLine) {
          if (sec.id === 'tech') {
            setActiveNav((prev) => (prev === 'security' ? 'security' : 'ai-agents'));
          } else {
            setActiveNav(sec.id);
          }
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && mobileMenuOpen) {
        setMobileMenuOpen(false);
      }
    };
    const handleResize = () => {
      if (window.innerWidth >= 992 && mobileMenuOpen) {
        setMobileMenuOpen(false);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('resize', handleResize);
    };
  }, [mobileMenuOpen]);

  const scrollToTop = useCallback(() => {
    setMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleNavClick = useCallback((item) => {
    setActiveNav(item.id);
    setMobileMenuOpen(false);

    if (item.techTab) {
      window.dispatchEvent(
        new CustomEvent('geekcode:switch-tech-tab', { detail: { tab: item.techTab } })
      );
    }

    const section = document.querySelector(item.target);
    if (section) {
      const top = section.getBoundingClientRect().top + window.scrollY - 76;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }, []);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`} role="banner">
      <div className="header-container">
        <div className="header-left">
          <button
            type="button"
            className="logo"
            onClick={scrollToTop}
            aria-label="IDEVault 回到顶部"
          >
            <img src={icons.logo1} alt="IDEVault" />
          </button>
          <span className="brand-tag">专有云研发平台</span>
        </div>

        <nav className="header-nav" aria-label="主导航">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              type="button"
              className={`nav-link ${activeNav === item.id ? 'active' : ''}`}
              onClick={() => handleNavClick(item)}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="header-right">
          <a
            className="console-login-btn"
            href="https://console.geekcode.cloud/login/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>登录控制台</span>
            <span className="btn-arrow" aria-hidden="true">↗</span>
          </a>

          <button
            type="button"
            className="mobile-menu-trigger"
            aria-label={mobileMenuOpen ? '关闭导航菜单' : '打开导航菜单'}
            aria-expanded={mobileMenuOpen}
            onClick={() => setMobileMenuOpen((prev) => !prev)}
          >
            <span className={`hamburger ${mobileMenuOpen ? 'open' : ''}`}>
              <i />
              <i />
              <i />
            </span>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="mobile-drawer" role="dialog" aria-label="移动端导航菜单">
          <div className="mobile-drawer-links">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.id}
                type="button"
                className={`mobile-nav-link ${activeNav === item.id ? 'active' : ''}`}
                onClick={() => handleNavClick(item)}
              >
                <span className="link-dot" aria-hidden="true" />
                <span className="link-text">{item.label}</span>
                <span className="link-arrow" aria-hidden="true">→</span>
              </button>
            ))}
          </div>
          <div className="mobile-drawer-footer">
            <a
              className="mobile-login-btn"
              href="https://console.geekcode.cloud/login/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setMobileMenuOpen(false)}
            >
              立即登录控制台 ↗
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
